<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="title">HITLER’S TRAITORS</h1>
<p class="subtitle">DISSENT, ESPIONAGE AND THE HUNT FOR RESISTERS</p>
<p class="author">EDWARD HARRISON</p>
<div class="img_containert">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?02d8d7a8